<mojo-side-nav
  #sidenav
  [opened]="opened"
  (wentBack)="goBack()"
  (closed)="close()"
>
  <ng-container header-title>Filters</ng-container>
  <ng-container header-actions>
    <a
      class="cursor-pointer"
      (click)="onClearFilters()"
    >CLEAR ALL</a>
  </ng-container>
  <ng-content></ng-content>
  <button
    class="show-results-button"
    (click)="onShowResult()"
    data-cy="side-nav-show-results-button"
  >SHOW RESULTS
    ({{totalResults}})</button>
</mojo-side-nav>
